import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';

export const StyledInput = styled.input`
  background-color: white;
  padding: 10px;
  color: grey;
  border-bottom: ${(props) => (props.error ? '2px solid red' : '0')};
  width: calc(100% - 20px);
  ${(props) => (props.noMargin ? 'margin:0' : 'margin: 10px 0')};
  font-size: 16px;
  border-width: 0px;
  outline: 0;
  margin-bottom: 10px;
  ${(props) => (props.disabled && 'background-color: #ccc')};
  
  &::placeholder {
   color: lightgrey;
  }
  
  @media (min-width: ${breakpoints.desktop}) {
    margin: 0;
  }
`;
